module.exports = __webpack_public_path__ + "static/SeeVita-03-cc34154a2ecc1a2d48736dca1c8a1dca.png";